import { AI_TOOLS_TYPE } from '../../constants/ai-event-type';
import qualityEvents from './quality-events';

export const aiStripeEvents = (url: string | null, id: number | string, typeEvent: string) => {
    if (url && url.includes('ai-tools/document')) {
        const match = url.match(/document\/(\d+)/);

        if (match && match[1]) {
            const documentId = match[1];

            const type = `${AI_TOOLS_TYPE.TRACK}:aiLangFlow:MaterialStripe:${typeEvent}`;
            const extra = id.toString();

            qualityEvents.ai.trackEvent(type, extra, documentId);
        }
    }
};
